module.exports = __webpack_public_path__ + "static/media/icon_cal.88474c35.svg";